import React from 'react';

import Stars from '../vector/stars';
import ThumbsUp from '../vector/thumbs_up';

import {
  Title,
  Picture,
  Name,
  NameBlock,
  Text,
  TextBlock,
  TextStars,
  TextThumbsUp,
  Points,
  Wrapper,
} from './styled';

const CardSmall = ({ user, points = 0, title = 'Nice One!' }) => (
  <Wrapper className="wrapper" size="small">
    <Title size="small">
      <TextThumbsUp>
        <ThumbsUp height="1.8em" />
      </TextThumbsUp>
      {title}
    </Title>

    <Picture src={user.links.avatar ? user.links.avatar : null} size="small" />

    <NameBlock>
      <Name size="small">
        {user.attributes.first_name} {user.attributes.last_name}
      </Name>
    </NameBlock>

    <TextBlock>
      <Text size="small">
        <Points>+{points}</Points> Points
        <TextStars>
          <Stars />
        </TextStars>
      </Text>
    </TextBlock>
  </Wrapper>
);

export default CardSmall;
